//import { JSX } from "react";
//import { Navigate } from "react-router-dom";

//interface PrivateRouteProps {
//  children: JSX.Element;
//}

//export function PrivateRoute({ children }: PrivateRouteProps) {

//  const isAuthenticated = localStorage.getItem("authToken");

//  if (!isAuthenticated) {
//    return <Navigate to="/" replace />;
//  }

 // return children;
//}

import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { ContextUser } from "../context/ContextUser/context";

export function PrivateRoute({ children }: any) {
  const { state } = useContext(ContextUser);

  if (state.loading) return <p>Carregando...</p>;

  if (!state.user) {
    return <Navigate to="/" replace />;
  }

  return children;
}